import * as React from 'react';
import {inject, observer} from 'mobx-react';
import logo from "../../../logo.jpg";
import UIStore from "../../stores/UIStore";
import {UIModel} from "../../models/UIModel";


// props for navigation
interface INavProps {
    UI_STORE?:UIStore;
}

/**
 * Container where all logic for the Navigation menu is rooted.
 */

@inject('UI_STORE')
@observer
export class Nav extends React.Component<INavProps, any> {

    /**
     *
     */
    public render():any {

        const uiModel:UIModel = this.props.UI_STORE!.ui;
        const uiStore:UIStore = this.props.UI_STORE!;

        return (
            <div className="topnav">
                <a href="https://www.vgift.com" target="_blank" rel="noopener noreferrer" className="logo"><img className="logo" src={logo} alt="VGift" height="30"/></a>
            </div>
        );
    }

}



